import React from "react";

import { OnlineLink, SupportLevelIcon } from "components";
import { getFullName } from "helpers";

import styles from "../search.module.scss";

export const merchantResultItem = (obj): { [key: string]: any } => {
	return (
		<div
			className={`${styles.wrappSearchInfo} flex-wrap`}
			style={{ justifyContent: "flex-start" }}
		>
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>MID:</p>
					{obj?.mid && obj?.id && (
						<p className="ml-3 d-flex">
							<SupportLevelIcon
								name={obj?.priorityType || obj?.priority_type}
							/>
							<OnlineLink
								to={`/merchant/list/info/${obj?.id}/general`}
								target="_blank"
								style={{ marginLeft: "7px" }}
							>
								{obj?.mid}
							</OnlineLink>
						</p>
					)}
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>DBA Name:</p>
					<p className={`break-word ${styles.content}`}>
						{obj.dbaName}
					</p>
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Processor / Sponsor:</p>
					<p className={styles.content}>
						{obj.processor} {obj.processor && "/"} {obj.sponsor}
					</p>
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Agent Office & Agent:</p>
					<div className={styles.content}>
						{obj?.primaryAgent?.company?.id && (
							<p className="mb-0">
								<OnlineLink
									to={`/system-setup/agent-office-setup/edit-agent-office/${obj?.primaryAgent?.company?.id}/general-info`}
									target="_blank"
								>
									{obj.agentOffice}
								</OnlineLink>
							</p>
						)}
						{obj?.primaryAgent?.id && (
							<p className="mb-0">
								<OnlineLink
									to={`/system-setup/agent-setup/edit-agent/${obj?.primaryAgent?.id}/general-info`}
									target="_blank"
								>
									{getFullName(obj?.primaryAgent)}
								</OnlineLink>
							</p>
						)}
					</div>
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Status:</p>
					<p className={styles.content}>{obj.status}</p>
				</div>
			}
		</div>
	);
};
